export default __webpack_public_path__ + "static/media/petgramImg_2.b5e88abd.png";